import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cartcheckout',
  templateUrl: './cartcheckout.component.html',
  styleUrls: ['./cartcheckout.component.css']
})
export class CartcheckoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
